<template>
  <div class="task">
    <div class="tabs">
      <div
        class="tab"
        :class="{ active: activeTab === 'todo' }"
        @click="activeTab = 'todo'"
      >
        我的待办
      </div>
      <div
        class="tab"
        :class="{ active: activeTab === 'completed' }"
        @click="activeTab = 'completed'"
      >
        已完成
      </div>
      <div
        class="tab"
        :class="{ active: activeTab === 'launch' }"
        @click="activeTab = 'launch'"
      >
        我发起的
        <div class="add" @click.stop="addTask">+</div>
      </div>
      <div
        class="tab"
        :class="{ active: activeTab === 'history' }"
        @click="activeTab = 'history'"
      >
        历史发起
      </div>
    </div>
    <taskList v-if="activeTab === 'todo'" key="todo" type="todo" />
    <taskList
      v-if="activeTab === 'completed'"
      key="completed"
      type="completed"
    />
    <taskList v-if="activeTab === 'launch'" key="launch" type="launch" />
    <taskList v-if="activeTab === 'history'" key="history" type="history" />
    <TaskModal :visible.sync="taskModalShow" />
  </div>
</template>

<script>
import taskList from "./taskList.vue";
import TaskModal from "./taskModal.vue";
export default {
  components: {
    TaskModal,
    taskList,
  },
  data() {
    return {
      activeTab: "todo",
      taskModalShow: false,
    };
  },
  mounted() {},
  methods: {
    addTask() {
      this.taskModalShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.task {
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;

  .tabs {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    padding: 0 20px;

    .tab {
      font-weight: bold;
      padding: 10px 20px;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      display: flex;
      align-items: center;

      &.active {
        color: #b78e6c;
        border-color: #b78e6c;
      }

      .add {
        width: 30px;
        height: 30px;
        border-radius: 100%;
        background-color: #b78e6c;
        color: #fff;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
